import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { useCreateStore } from "@/api/onboarding/create-store";
import { Button } from "@/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import useGlobalLoading from "@/store/global-loading";
import { useEffect } from "react";

const formSchema = z.object({
    website_url: z
        .string({
            required_error: "Store url is required",
            invalid_type_error: "Store url be a string",
        })
        .url({ message: "Website url must be a valid url" }),
});

const StoreInfoForm = () => {
    const form = useForm<z.infer<typeof formSchema>>({
        resolver: zodResolver(formSchema),
        defaultValues: {
            website_url: "",
        },
    });

    const { setIsLoading } = useGlobalLoading();

    const { mutate: createStore, isPending: isCreateStorePending, isSuccess: isCreateStoreSuccess } = useCreateStore();

    function onSubmit(values: z.infer<typeof formSchema>) {
        createStore({ name: values.website_url });
        setIsLoading(true);
    }

    useEffect(() => {
        if (isCreateStoreSuccess || isCreateStorePending) {
            setIsLoading(true);
        }
    }, [isCreateStorePending, isCreateStoreSuccess, setIsLoading]);

    return (
        <div>
            <Form {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)} className="grid grid-cols-2 gap-4">
                    <div className="col-span-2">
                        <FormField
                            control={form.control}
                            name="website_url"
                            render={({ field }) => (
                                <FormItem>
                                    <FormLabel className="text-base">Your website URL*</FormLabel>
                                    <small>(This URL will be used to create your store.)</small>
                                    <FormControl>
                                        <Input className="py-6" placeholder="Enter website URL" {...field} />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />
                    </div>

                    <div className="col-span-2 flex justify-end">
                        <Button type="submit">Next</Button>
                    </div>
                </form>
            </Form>
        </div>
    );
};

export default StoreInfoForm;
